import { render, staticRenderFns } from "./AppDialog.vue?vue&type=template&id=febf0bc6"
import script from "./AppDialog.vue?vue&type=script&lang=js"
export * from "./AppDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports